export const SPORTS = [
  { key: "cycling", label: "Cycling", levels: ["Beginner", "Intermediate", "Experienced", "Elite"] },
  { key: "running", label: "Running", levels: ["Casual", "Medium Pace", "Competitive"] },
  { key: "padel",   label: "Padel",   levels: ["Beginner", "Intermediate", "Advanced", "Competitive"] },
];

export const FITNESS_LEVELS = ["Beginner", "Intermediate", "Experienced", "Elite"];
